import image1 from "assets/img/about-project/o-projekcie-1.jpg";
import image2 from "assets/img/about-project/o-projekcie-2.jpg";
import image3 from "assets/img/about-project/o-projekcie-3.jpg";
import image4 from "assets/img/about-project/o-projekcie-4.jpg";
import image5 from "assets/img/about-project/o-projekcie-5.jpg";
import image6 from "assets/img/about-project/o-projekcie-6.jpg";
import image7 from "assets/img/about-project/o-projekcie-7.jpg";
import "assets/scss/archive/mine-now.scss";
import "assets/scss/Components/spyscroll.scss";
import { useLayoutEffect } from "react";
import { Fragment, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Scrollspy from "react-scrollspy";

const AboutProject = ({
  setPageTitle,
  setShowMenuToggler,
  setIsBackgroundMusic,
  setReturnLink,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    setPageTitle(t("About the Project"));
    setShowMenuToggler(true);
    setIsBackgroundMusic(true);
    setReturnLink({ link: "/scene" });
  }, [setPageTitle, setShowMenuToggler, setReturnLink, setIsBackgroundMusic]);

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Fragment>
      <div className="scrollspy-wrapper">
        {/* check section */}
        <Scrollspy
          className="scrollspy"
          items={[
            "section-1",
            "section-2",
            "section-3",
            "section-4",
            "section-5",
            "section-6",
            "section-7",
          ]}
          currentClassName="active"
        >
          <li>
            <a href="#section-1">&nbsp;</a>
          </li>
          <li>
            <a href="#section-2">&nbsp;</a>
          </li>
          <li>
            <a href="#section-3">&nbsp;</a>
          </li>
          <li>
            <a href="#section-4">&nbsp;</a>
          </li>
          <li>
            <a href="#section-5">&nbsp;</a>
          </li>
          <li>
            <a href="#section-6">&nbsp;</a>
          </li>
          <li>
            <a href="#section-7">&nbsp;</a>
          </li>
        </Scrollspy>
      </div>
      <div className="bg-black">
        <section id="section-1">
          <div className="container-fluid px-4 z-index-11 vh-100 d-flex justify-content-center align-items-center">
            <div className="row gx-5 my-100 px-3">
              <div className="col-6 mx-auto">
                <h3
                  dangerouslySetInnerHTML={{
                    __html: t("AboutProjectSection1Content"),
                  }}
                ></h3>
              </div>
            </div>
            <div
              style={{ marginRight: "212px", marginBottom: "66px" }}
              className="fs-bigBody position-absolute bottom-0 end-0 col-3 px-5"
            >
              {t("AboutProjectSection1Content2")}
            </div>
          </div>
          <img
            src={image1}
            className="w-100 h-100 position-absolute z-index-10 dark-layer"
            alt=""
          />
        </section>
        <section id="section-2" style={{ marginTop: "5px" }}>
          <div className="container-fluid px-4 z-index-11 d-flex flex-column pb-5 pt-1 mt-200 ">
            <div className="mx-auto">
              <img src={image2} alt="" style={{ width: "890px" }} />
            </div>
            <div
              style={{ marginTop: "-90px" }}
              className="col-6 mb-200 ms-auto pe-3 me-5"
            >
              <h3
                className="fw-normal px-3"
                dangerouslySetInnerHTML={{
                  __html: t("AboutProjectSection2Content"),
                }}
              ></h3>
              <span className="fs-14 text-uppercase mt-5 px-3 d-block">
                {t("AboutProjectSection2Content1")}
              </span>
            </div>
          </div>
        </section>
        <section id="section-3" style={{ marginTop: "5px" }}>
          <div className="container-fluid px-4 z-index-11 d-flex">
            {/* <div className="container-fluid px-4 mx-3 z-index-11 d-flex flex-row pb-5 pt-1"> */}
            <div className="row gx-5 my-100 px-3">
              <div className="d-flex flex-column col-6">
                <img src={image3} alt="" />
              </div>
              <div className="col-6">
                <h3>{t("AboutProjectSection3Content")}</h3>
              </div>
            </div>
          </div>
        </section>
        <section id="section-4" style={{ marginTop: "5px" }}>
          <div className="container-fluid px-0 z-index-11 d-flex flex-column my-100">
            <img src={image4} className="w-100" alt="" />
          </div>
        </section>
        <section id="section-5" style={{ marginTop: "5px" }}>
          <div className="container-fluid px-4 z-index-11 d-flex flex-column pb-5 pt-1 mt-200 ">
            <div className="mx-auto">
              <img src={image5} alt="" style={{ width: "890px" }} />
            </div>
            <div
              style={{ marginTop: "-90px" }}
              className="col-6 mb-200 ms-auto pe-3 me-5"
            >
              <h3 className="fw-normal px-3">
                {t("AboutProjectSection5Content")}
              </h3>
            </div>
          </div>
        </section>
        <section id="section-6" style={{ marginTop: "5px" }}>
          <div className="container-fluid px-4 z-index-11 d-flex">
            {/* <div className="container-fluid px-4 mx-3 z-index-11 d-flex flex-row pb-5 pt-1"> */}
            <div className="row gx-5 my-100 px-3">
              <div className="d-flex flex-column col-6">
                <img src={image6} alt="" />
              </div>
              <div className="col-6">
                <h3>{t("AboutProjectSection6Content")}</h3>
                <h3 className="mt-5">{t("AboutProjectSection6Content2")}</h3>
                <h3 className="mt-5">{t("AboutProjectSection6Content3")}</h3>
                <h3 className="fw-normal mt-5">
                  {t("AboutProjectSection6Content4")}
                </h3>
              </div>
            </div>
          </div>
        </section>
        <section id="section-7" style={{ marginTop: "5px" }}>
          <div className="container-fluid px-0 z-index-11 d-flex flex-column my-100">
            <img src={image7} className="w-100" alt="" />
          </div>
        </section>
      </div>
    </Fragment>
  );
};

export default AboutProject;
